import Data from "./data.svg?react";
import Monitor from "./monitor.svg?react";
import OrdinaryDay from "./ordinary-day.svg?react";
import PublishPost from "./publish-post.svg?react";
import ServerDown from "./server-down.svg?react";
import Uploading from "./uploading.svg?react";
import WallPost from "./wall_post.svg?react";

export const Svg = {
	Data,
	WallPost,
	ServerDown,
	Uploading,
	PublishPost,
	Monitor,
	OrdinaryDay,
} as const;
